import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.ISSUES_FORM]: {
		el: {
			'Actual Start Date is required to close this ticket!': 'Η πραγματική ημερομηνία έναρξης απαιτείται για να κλείσετε την εργασία!',
			'Please fill all required fields to continue!': 'Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία για να συνεχίσετε!',
			'Invalid date or time': 'Μη έγκυρη ημερομηνία ή ώρα',
			'Confirm you wish to create a follow up ticket.': 'Επιβεβαίωση δημιουργίας σχετιζόμενης εργασίας.',
			'Follow Up': 'Σχετιζόμενη Εργασία',
			'Modification Date': 'Ημερομηνία Επεξεργασίας',
			'Modified By': 'Επεξεργασία Από',
			'Max allowed value 99999999.99': 'Μέγιστη επιτρεπόμενη τιμή 99999999.99',
			'Subcontractor Charge': 'Κόστος Υπεργολάβου',
			'Customer Cost': 'Κόστος Πελάτη',
			'Invalid time': 'Μη έγκυρη ώρα',
			'Est. Start Time': 'Εκτιμ. Ώρας Έναρξης',
			'Est. Expiry Time': 'Εκτιμ. Ώρας Λήξης',
			'Financial Info': 'Οικονομικά Στοιχεία',
			'Timeline': 'Χρονοδιάγραμμα',
			'Invalid date': 'Μη έγκυρη ημερομηνία',
			'No notes found!': 'Δεν βρέθηκαν καταχωρημένα σχόλια!',
			'No assets found!': 'Δεν βρέθηκε καταχωρημένος εξοπλισμός!',
			'No items found!': 'Δεν βρέθηκαν καταχωρημένα είδη!',
			'No attachments found!': 'Δεν βρέθηκαν καταχωρημένα επισυναπτόμενα!',
			'Assets': 'Εξοπλισμός',
			'Reference Code': 'Κωδικός Αναφοράς',
			'Please wait...': 'Παρακαλώ Περιμένετε...',
			'Comment': 'Σχόλιο',
			'Confirm you wish to continue with this action.': 'Επιβεβαίωση αλλαγής κατάστασης εργασίας.',
			'Add': 'Προσθήκη',
			'Search Address Suppliers': 'Αναζήτηση Προμηθευτών Διεύθυνσης',
			'Actions': 'Ενέργειες',
			'General Information': 'Γενικά Στοιχεία',
			'Technical Details': 'Τεχνικά Στοιχεία',
			'Work': 'Εργασία',
			'Code': 'Κωδικός',
			'Description': 'Περιγραφή',
			'Customer': 'Πελάτης',
			'Creator': 'Δημιουργός',
			'Status': 'Κατάσταση',
			'Est. Start': 'Εκτιμ. Έναρξη',
			'Est. Expiry': 'Εκτιμ. Λήξη',
			'Targeted Start': 'Συμβατική Ημ/νία 1ης Επίσκεψης',
			'Actual Visit Date': 'Πραγματική Ημ/νία 1ης Επίσκεψης',
			'Targeted Expiry': 'Συμβατική Λήξη',
			'Targeted Start Time': 'Συμβατική Ώρα 1ης Επίσκεψης',
			'Actual Visit Time': 'Πραγματική Ώρα 1ης Επίσκεψης',
			'Targeted Expiry Time': 'Συμβ. Ώρα Λήξης',
			'Duration': 'Διάρκεια',
			'Duration (Days)': 'Διάρκεια (Μέρες)',
			'Summary': 'Περίληψη',
			'Active': 'Ενεργό',
			'Billable': 'Χρεώσιμο',
			'Template': 'Πρότυπο',
			'Fixed Start': 'Σταθερή Έναρξη',
			'Fixed End': 'Σταθερό Τέλος',
			'Assignee': 'Υπεύθυνος',
			'Team': 'Τμήμα',
			'Item': 'Είδος',
			'Contact': 'Επαφή',
			'Address': 'Διεύθυνση',
			'Priority': 'Προτεραιότητα',
			'Type': 'Τύπος',
			'Est. Work': 'Εκτιμ. Εργασία',
			'Actual Work': 'Πραγμ. Εργασία',
			'Enter issue\'s description': 'Εισαγάγετε την περιγραφή της εργασίας',
			'On Behalf': 'Εκ μέρους',
			'Customer Details': 'Στοιχεία πελάτη',
			'Financially': 'Οικονομικά',
			'Proposed Work': 'Προτειν. Εργασία',
			'Est. Cost': 'Εκτιμ. Κόστος',
			'Charge': 'Χρέωση',
			'Kind': 'Ιδιότητα',
			'Completed (%)': 'Ολοκληρωμένο (%)',
			'Invoiced': 'Τιμολογημένο',
			'General': 'Γενικά',
			'Details': 'Λεπτομέρειες',
			'Issue': 'Εργασία',
			'Notes ': 'Σημειώσεις',
			'Observers': 'Παρατηρητές',
			'Related': 'Σχετικές Εργασίες',
			'Predecessor': 'Προκάτοχοι',
			'Charges': 'Χρεώσεις',
			'History': 'Ιστορικό',
			'Amount': 'Αξία',
			'Submit Date': 'Ημέρα Δημιουργίας',
			'User': 'Χρήστης',
			'Messages': 'Μηνύματα',
			'Send Date': 'Ημ/νία αποστολής',
			'Subject': 'Υπόμνημα',
			'Sender Name': 'Αποστολέας',
			'Date': 'Ημ/νία',
			'Expenses': 'Έξοδα',
			'Serial Number': 'Σειριακός αριθμός',
			'Duration (Hours)': 'Διάρκεια(Ώρες)',
			'Start': 'Έναρξη',
			'End': 'Λήξη',
			'Estimate': 'Εκτίμηση',
			'Real': 'Πραγματικό',
			'Charge (Hours)': 'Χρέωση (Ώρες)',
			'Work (Hours)': 'Εργασία (Ώρες)',
			'Start - End': 'Έναρξη - Λήξη',
			'Comments': 'Σχόλια',
			'Works': 'Εργασίες',
			'Enter Comments': 'Προσθέστε σχόλια',
			'Attachments': 'Επισυναπτόμενα',
			'Customer/Item': 'Πελάτης/Είδος',
			'Resolve Issue': 'Ολοκλήρωση Εργασίας',
			'There is no attachment for this issue': 'Δεν υπάρχει συνημμένο για αυτήν την εργασία',
			"Start date can't be later than end date!": "Η ημ/νία έναρξης δεν μπορεί να είναι μετά την ημ/νία λήξης!",
			'Return': 'Επιστροφή',
			'Save': 'Αποθήκευση',
			'New Issue': 'Καταχώρηση Νέας Εργασίας',
			'Copy Issue': 'Αντιγραφή Issue',
			'Edit Issue': 'Επεξεργασία Εργασίας',
			'Items': 'Είδη',
			'Quantity': 'Ποσότητα',
			'Price': 'Τιμή',
			'Value': 'Αξία',
			'Either Item or Description is required': 'Απαιτείται είτε το είδος είτε η περιγραφή',
			'Total Value': 'Συνολική Αξία',
			'Please Wait...': 'Παρακαλώ Περιμένετε...',
			'Contact Description': 'Περιγραφή Επαφής',
			'Item Category': 'Κατηγορία Είδους',
			'Project': 'Έργο',
			'Write a comment...': 'Γράψτε ένα σχόλιο...',
			'Item/Service': 'Είδος/Υπηρεσία',
			'Required': 'Απαιτείται',
			'Technicians': 'Τεχνικοί',
			'Technician': 'Τεχνικός',
			'Checklists': 'Λίστες Ελέγχου',
			'Subcontractor': 'Υπεργολάβος',
			'Issue Type': 'Τύπος Εργασίας',
			'Alternative Type': 'Εναλλακτικός Τύπος',
			'Dimension': 'Διάσταση',
			'Service Category': 'Κατηγορία Υπηρεσίας',
			'Service': 'Υπηρεσία',
			'Applicant': 'Αιτών',
			'Complete': 'Ολοκλήρωση',
			'Pending': 'Εκκρεμότητα',
			'Cancel': 'Ακύρωση',
			'Submit Dt': 'Ημέρα Δημιουργίας',
			'Actual Start': 'Πραγματική Έναρξη',
			'Actual End': 'Πραγματική Λήξη',
			'Date Registered': 'Ημ/νία Καταχώρησης',
			'Main Contact': 'Κύρια Επαφή',
			'Main Contact Email': 'Email Κύριας Επαφής',
			'Main Contact Phone': 'Τηλ. Κύριας Επαφής',
			'Name': 'Όνομα',
			'Phone': 'Τηλέφωνο',
			'Contact Info': 'Πληροφορίες Επαφής',
			'Erp Code': 'Κωδικός Erp',
			'An error occurred!': 'Προέκυψε ένα σφάλμα!',
			'Invalid Date': 'Μη έγκυρη ημερομηνία',
			'Enter no more than 250 characters.' : 'Πληκτρολογείστε λιγότερο από 250 χαρακτήρες.',
			'Issue created successfully!' : 'Η Εργασία δημιουργήθηκε με επιτυχία!',
			'Issue updated successfully!' : 'Η Εργασία ανανεώθηκε με επιτυχία!',
			'Issue copy successfully!' : 'Η Εργασία αντιγράφηκε με επιτυχία!',
			'The serial number does not exist!' : 'Ο Σειριακός Αριθμός δεν υπάρχει!',
			'Inability' : 'Αδυναμία',
			'Auditing History' : 'Έλεγχος Ιστορικού',
			'Ref. Code' : 'Κωδικός Ανάφ.',
			'Contact Email': 'Email Επαφής',
			'Offer': 'Προσφορά',
			'Submit Customer Offer (SO)': 'Αποστολή Προσφοράς Πελάτη (SO)',
			'Percentage': 'Ποσοστό',
			'Surcharge': 'Επιβάρυνση',
			'Surcharges': 'Επιβαρύνσεις',
			'Total': 'Σύνολο',
			'Note': 'Παρατήρηση',
			'Items Total': 'Σύνολο Ειδών',
			'Items Total With Charges': 'Σύνολο Ειδών Με Επιβαρύνσεις',
			'Contract Benefit (Markup)': 'Εργολαβικό Όφελος (Markup)',
			'Discount': 'Έκπτωση',
			'Final Total': 'Τελικό Σύνολο',
			'Total With Markup': 'Σύνολο Με Εργολαβικό Όφελος',
			'Total With Discount': 'Σύνολο Με Έκπτωση',
			'Customer offer submitted successfully!': 'Η προσφορά πελάτη υποβλήθηκε με επιτυχία!',
			'Customer offer sent successfully!': 'Η προσφορά πελάτη έχει αποσταλεί με επιτυχία!',
			'email_subject': 'Θέμα',
			'Invalid email': 'Μη έγκυρο email',
			'Send': 'Αποστολή',
			'Recipients Information': 'Πληροφορίες Παραληπτών',
			'Body': 'Περιεχόμενο',
			'Email Offer': 'Αποστολή Προσφοράς',
			'At least one item is required': 'Εισάγετε τουλάχιστον ένα είδος',
			'Charge description and percentage must both be filled or both empty': 'Η επιβάρυνση και το ποσοστό πρέπει να είναι είτε και τα δύο συμπληρωμένα είτε κενά',
			'Offers': 'Προσφορές',
			'Recipients': 'Παραλήπτες',
			'Approved': 'Εγκρίθηκε',
			'Rejected': 'Απορρίφτηκε',
			'File': 'Αρχείο',
			'Calculated discount can not be more that total': 'Η έκπτωση που εφαρμόζεται δεν μπορεί να είναι μεγαλύτερη από το σύνολο της προσφοράς',
			'Status change date': 'Ημ/νία αλλαγής κατάστασης',
			'Replied By': 'Απαντήθηκε Από',
			'PO Code':'Κωδικός P.O',
			'Contact name':"Επαφή",
			'Customer name':"Πελάτης",
			'SO Code':'Κωδικός S.O',
			'PO Cust Code':'Κωδικός P.O Πελάτη',
			'General Information P.O':'Γενικά στοιχεία P.O',
			'General Information S.O':'Γενικά στοιχεία S.O',
			'General Information Customer P.O':'Γενικά στοιχεία P.O Πελάτη',
			"Delete selected rows":"Διαγραφή επιλεγμένων γραμμών",
			"Delete P.O":"Διαγραφή P.O",
			'P.O deleted successfully!':"Το P.O διαγράφηκε με επιτυχία!",
			"Delete S.O":"Διαγραφή S.O",
			'S.O deleted successfully!':"Το S.O διαγράφηκε με επιτυχία!",
			'New Charge':'Νέα χρέωση',
			"Saved successfully!":"Αποθηκεύτηκε με επιτυχία!",
			'Internal Assignment': 'Εσωτερική Ανάθεση',
			"Couldn't complete ticket, because there's an open survey!" : "Δεν ήταν δυνατή η ολοκλήρωση του θέματος, επειδή υπάρχει μια ανοιχτή έρευνα!",
			'Customer PO Code' : 'Κωδικός PO Πελάτη',
			'P.O send successfully!':"Το P.O στάλθηκε με επιτυχία!",
			'S.O send successfully!':"Το S.O στάλθηκε με επιτυχία!",
			'missing Dimension!':"λείπει η διάσταση!",
			'missing Item!':"λείπει το είδος!",
			'missing Item and Dimension!':"λείπει το είδος και η διάσταση!",
			'Face Internal Assignment':'Εσωτερική ανάθεση σε πρόσωπο',
			'Internal Comments': 'Εσωτερικά Σχόλια',
			'Send Email': 'Αποστολή Email',
			'To': 'Προς',
			'Cc': 'Κοινοποίηση',
			'Message Code': 'Κωδικός Μηνύματος',
			'Created At': 'Ημ/νία Δημιουργίας',
			'Preview': 'Προεπισκόπηση',
			'ErpCode':'Κωδικός Erp',
			'One description':'Περιγραφή τιμολόγησης',
		},
		en: {
			'Submit Dt': 'Submit Date',
			'email_subject': 'Subject'
		}
	},
	[Namespaces.ISSUES_GLOBAL]: {
		el: {
			'Service Category': 'Κατηγορία Υπηρεσίας',
			'Targeted Start': 'Συμβατική Ημ/νία 1ης Επίσκεψης',
			'Actual Visit Date': 'Πραγματική Ημ/νία 1ης Επίσκεψης',
			'Targeted Expiry': 'Συμβατική Λήξη',
			'Targeted Start Time': 'Συμβατική Ώρα 1ης Επίσκεψης',
			'Actual Visit Time': 'Πραγματική Ώρα 1ης Επίσκεψης',
			'Targeted Expiry Time': 'Συμβατική Ώρα Λήξης',
			'Est. Start Time': 'Εκτιμ. Ώρα Έναρξης',
			'Est. Expiry Time': 'Εκτιμ. Ώρα Λήξης',
			'Export failed': 'Η εξαγωγή απέτυχε!',
			'No data found to export!': ' Δεν βρέθηκαν αποτελέσματα για εξαγωγή!',
			'Filter Options': 'Επιλογές Φίλτρων',
			'Site Code': 'Κωδ. Site',
			'Reference Code': 'Κωδ. Αναφοράς',
			'Erp Code': 'Κωδ. Erp',
			'Failed to export!': 'Η εξαγωγή απέτυχε!',
			'Export': 'Εξαγωγή',
			'Please wait...': 'Παρακαλώ Περιμένετε...',
			'Actions': 'Ενέργειες',
			'Issues': 'Eργασίες',
			'Edit': 'Επεξεργασία',
			'Subcontractor Charge': 'Κόστος Υπεργολάβου',
			'Customer Cost': 'Κόστος Πελάτη',
			'Work': 'Εργασία',
			'Works': 'Εργασίες',
			'Timeline': 'Χρονοδιάγραμμα',
			'Code': 'Κωδικός',
			'Description': 'Περιγραφή',
			'Customer': 'Πελάτης',
			'Creator': 'Δημιουργός',
			'Status': 'Κατάσταση',
			'Est. Start': 'Εκτιμ. Έναρξη',
			'Est. Expiry': 'Εκτιμ. Λήξη',
			'Duration': 'Διάρκεια',
			'Duration (Days)': 'Διάρκεια (Μέρες)',
			'Summary': 'Περίληψη',
			'Active': 'Ενεργό',
			'Billable': 'Χρεώσιμο',
			'Assignee': 'Υπεύθυνος',
			'Item': 'Είδος',
			'Priority': 'Προτεραιότητα',
			'Type': 'Τύπος',
			'Kind': 'Ιδιότητα',
			'Contact': 'Επαφή',
			'Charge': 'Χρέωση',
			'Issue Details': 'Στοιχεία Εργασίας',
			'TmStart': 'Έναρξη',
			'Expenses': 'Έξοδα',
			'Resolved': 'Επίλυση',
			'Copy': 'Αντιγραφή',
			'Reopen': 'Άνοιγμα',
			'General': 'Γενικά',
			'Customer/Item': 'Πελάτης/Είδος',
			'Do you want to reopen this issue?': 'Θα θέλατε να ξανανοίξετε αυτήν την εργασία;',
			'Cancel': 'Ακύρωση',
			'Save': 'Αποθήκευση',
			'Attachments': 'Επισυναπτόμενα',
			'Serial Number': 'Σειριακός αριθμός',
			'Template': 'Πρότυπο',
			'Fixed Start': 'Σταθερή Έναρξη',
			'Fixed End': 'Σταθερό Τέλος',
			'Team': 'Τμήμα',
			'Address': 'Διεύθυνση',
			'Est. Work': 'Εκτιμ. Εργασία',
			'Actual Work': 'Πραγμ. Εργασία',
			'Enter issue\'s description': 'Εισαγάγετε την περιγραφή της εργασίας',
			'On Behalf': 'Εκ μέρους',
			'Customer Details': 'Στοιχεία πελάτη',
			'Financially': 'Οικονομικά',
			'Proposed Work': 'Προτειν. Εργασία',
			'Est. Cost': 'Εκτιμ. Κόστος',
			'Completed (%)': 'Ολοκληρωμένο (%)',
			'Invoiced': 'Τιμολογημένο',
			'Details': 'Λεπτομέρειες',
			'Issue': 'Εργασία',
			'Notes': 'Σημειώσεις',
			'Observers': 'Παρατηρητές',
			'Related': 'Σχετικές Εργασίες',
			'Predecessor': 'Προκάτοχοι',
			'Charges': 'Χρεώσεις',
			'History': 'Ιστορικό',
			'Amount': 'Αξία',
			'Submit Date': 'Ημέρα Δημιουργίας',
			'User': 'Χρήστης',
			'Messages': 'Μηνύματα',
			'Send Date': 'Ημ/νία αποστολής',
			'Subject': 'Υπόμνημα',
			'Sender Name': 'Αποστολέας',
			'Date': 'Ημ/νία',
			'Duration (Hours)': 'Διάρκεια(Ώρες)',
			'Start': 'Έναρξη',
			'End': 'Λήξη',
			'Estimate': 'Εκτίμηση',
			'Real': 'Πραγματικό',
			'Charge (Hours)': 'Χρέωση (Ώρες)',
			'Work (Hours)': 'Εργασία (Ώρες)',
			'Start - End': 'Έναρξη - Λήξη',
			'Comments': 'Σχόλια',
			'Enter Comments': 'Προσθέστε σχόλια',
			'Resolve Issue': 'Ολοκλήρωση Εργασίας',
			'There is no attachment for this issue': 'Δεν υπάρχει συνημμένο για αυτήν την εργασία',
			'Project' : 'Έργο',
			'Estim. Start': 'Εκτιμ. Έναρξη',
			'Estim. Start Time': 'Εκτιμ. Ώρα Έναρξης',
			'Estim. Expiry': 'Εκτιμ. Λήξη',
			'Estim. Expiry Time': 'Εκτιμ. Ώρα Λήξης',
			'Search' : 'Αναζήτηση',
			'Clear' : 'Καθαρισμός',
			'Actual Start': 'Πραγματική Έναρξη',
			'Actual End': 'Πραγματική Λήξη',
			'Start date was after end date, adjusted end date to match.' : 'Η ημερομηνία έναρξης ήταν μετά την ημερομηνία λήξης, προσαρμόστηκε η ημερομηνία λήξης ώστε να ταιριάζει.',
			'End date was before start date, adjusted to match start.' : 'Η ημερομηνία λήξης ήταν πριν από την ημερομηνία έναρξης, προσαρμόστηκε ώστε να ταιριάζει με την ημερομηνία έναρξης.',
			'Subcontractor' : 'Υπεργολάβος',
			'Service': 'Υπηρεσία',
			'Submit Dt': 'Ημέρα Δημιουργίας',
			'Work Code' : 'Κωδικός Εργασίας',
			'Dimension' : 'Διάσταση',
			'Technician' : 'Τεχνικός',
			'Total':'Σύνολο',
			'Create P.O':'Δημιουργία P.O',
			'Create S.O':'Δημιουργία S.O',
			'Create Customer P.O':'Δημιουργία P.O Πελάτη',
			'No selected tickets':'Δεν υπάρχουν επιλεγμένες εργασίες',
			'Selected tickets for':'Επιλεγμένες εργασίες για',
			'Select one assignee or status':'Διαλέξτε ένα υπεργολάβο ή status',
			'Search with one assignee or status selected':'Αναζητήστε επιλέγοντας έναν υπεργολάβο ή status',
			'Select one or more rows to create a P.O':'Επιλέξτε μια ή παραπάνω γραμμές για να δημιουργήσετε ένα P.O',
			'PO Code':'Κωδικός P.O',
			'SO Code':'Κωδικός S.O',
			'PO Cust Code':'Κωδικός P.O Πελάτη',
			"Please run a search first!":"Εκτελέστε μια αναζήτηση!",
			"Select exactly one assignee and status":"Διαλέξτε  έναν υπεργολάβο και ένα status",
			"Select exactly one customer and status":"Διαλέξτε  έναν πελάτη και ένα status",
			"Some selected rows already have a PO Code. Please deselect them to proceed.":"Μερικές γραμμές είναι ήδη σε PO.Παρακαλώ επιλέξτε μόνο όσες δεν συμμετέχουν σε PO  για να συνεχίσετε",
			"Some selected rows already have a SO Code. Please deselect them to proceed.":"Μερικές γραμμές είναι ήδη σε SO.Παρακαλώ επιλέξτε μόνο όσες δεν συμμετέχουν σε SO  για να συνεχίσετε",
			"Some selected rows already have a PO Cust Code. Please deselect them to proceed.":"Μερικές γραμμές είναι ήδη σε PO πελάτη.Παρακαλώ επιλέξτε μόνο όσες δεν συμμετέχουν σε PO πελάτη  για να συνεχίσετε",
			"Select at least one row from the results":"Επιλέξτε τουλάχιστον μια γραμμή από τα αποτελέσματα της αναζήτησης",
			"Enter P.O description":"Περιγραφή P.O",
			"Customer P.O":"P.O πελάτη",
			'P.O created successfully!':"To P.O δημιουργήθηκε με επιτυχία!",
			'S.O created successfully!':"To S.O δημιουργήθηκε με επιτυχία!",
			'Customer P.O created successfully!':"To P.O του πελάτη δημιουργήθηκε με επιτυχία!",
			'PO Code is required!':"Ο κωδικός PO είναι υποχρεωτικός!",
			"Enter S.O description":"Περιγραφή S.O",
			'P.O Cust Information':'Στοιχεία P.O Πελάτη',
			'Create':'Καταχώριση',
			"Do you want to add in already existing PO or create new?":"Θέλετε να προσθέσετε σε PO που υπάρχει ήδη ή να δημιουργήσετε καινούριο?",
			"Add in already existing PO":"Προσθήκη σε PO που υπάρχει ήδη",
			"Select a P.O":"Επιλέξτε ένα PO",
			"Do you want to add in already existing SO or create new?":"Θέλετε να προσθέσετε σε SO που υπάρχει ήδη ή να δημιουργήσετε καινούριο?",
			"Add in already existing SO":"Προσθήκη σε SO που υπάρχει ήδη",
			"Select a S.O":"Επιλέξτε ένα SO",
			'Editable Charge':"Επεξεργασία χρέωσης",
			'Store and save':"Αποθήκευση",
			'Work Type' : 'Τύπος Εργασίας',
			'Internal Assignment' : 'Εσωτερική Ανάθεση',
			'Has one description':'Εχει περιγραφή τιμολόγησης',
			'One description':'Περιγραφή τιμολόγησης',
			'Enter Description':'Περιγραφή',
			'Technicians':'Τεχνικοί',
			'PO Code must match the PO Cust Code of all the selected tickets':'Ο κωδικός PO πρέπει να ταιριάζει με τον κωδικό PO Πελάτη όλων των επιλεγμένων εργασιών'
		},
		en: {
			'Submit Dt': 'Submit Date',
		}
	}
}

export default locales